function MessageReceiverControlRegistrationParams(definition, group, path, keys) {
    this.definition = definition;
    this.group = group;
    this.path = path;
    this.keys = keys;
}

module.exports = MessageReceiverControlRegistrationParams;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/message-receiver-control-registration-params.js
// module id = 473
// module chunks = 1